import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import './CookieConsent.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCookieBite,  
  faCheck, 
  faBan
} from '@fortawesome/free-solid-svg-icons';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Vérifier si l'utilisateur a déjà fait un choix
    const cookieChoice = Cookies.get('cookie_consent');
    
    if (!cookieChoice) {
      setShowBanner(true);
    }
  }, []);

  // Fonction pour sauvegarder le choix
  const saveCookiePreferences = (choice) => {
    // Sauvegarder le choix global
    Cookies.set('cookie_consent', choice, { 
      expires: 365,
      secure: process.env.NODE_ENV === 'production',
      sameSite: 'strict'
    });

    // Activer/désactiver les cookies selon le choix
    if (choice === 'all') {
      // Tout accepter
      Cookies.set('analytics_enabled', 'true', { expires: 365 });
      Cookies.set('marketing_enabled', 'true', { expires: 365 });
      Cookies.set('preferences_enabled', 'true', { expires: 365 });
      console.log('Tous les cookies acceptés');
    } else if (choice === 'necessary_only') {
      // Accepter quelques uns (nécessaires seulement)
      Cookies.remove('analytics_enabled');
      Cookies.remove('marketing_enabled');
      Cookies.remove('preferences_enabled');
      console.log('Cookies nécessaires seulement');
    } else if (choice === 'rejected') {
      // Refuser tout (nécessaires quand même activés)
      Cookies.remove('analytics_enabled');
      Cookies.remove('marketing_enabled');
      Cookies.remove('preferences_enabled');
      console.log('Cookies refusés (nécessaires seulement)');
    }

    setShowBanner(false);
  };

  // Options principales
  const acceptAll = () => {
    saveCookiePreferences('all');
  };

  const acceptSome = () => {
    saveCookiePreferences('necessary_only');
  };

  const rejectAll = () => {
    saveCookiePreferences('rejected');
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-banner">
        {/* En-tête */}
        <div className="cookie-header">
          <div className="cookie-icon-title">
            <FontAwesomeIcon icon={faCookieBite} className="cookie-main-icon" />
            <div>
              <h3 className="cookie-title">Votre vie privée nous importe</h3>
              <p className="cookie-subtitle">Gestion des cookies</p>
            </div>
          </div>
        </div>

        {/* Message principal */}
        <div className="cookie-message">
          <p>
            Nous utilisons des cookies pour améliorer votre expérience, analyser le trafic 
            et personnaliser le contenu. Les cookies nécessaires sont toujours activés. 
            Vous pouvez choisir d'accepter ou refuser les autres types.
          </p>
          <a 
            href="/politique-cookies" 
            target="_blank" 
            rel="noopener noreferrer"
            className="cookie-policy-link"
          >
            En savoir plus sur notre politique de cookies
          </a>
        </div>

        {/* Actions principales - 3 BOUTONS */}
        <div className="cookie-actions">
          <button 
            className="btn btn-accept-all"
            onClick={acceptAll}
          >
            <FontAwesomeIcon icon={faCheck} />
            Tout accepter
          </button>
          
          <button 
            className="btn btn-accept-some"
            onClick={acceptSome}
          >
            <FontAwesomeIcon icon={faCookieBite} />
            Accepter quelques uns
          </button>
          
          <button 
            className="btn btn-reject"
            onClick={rejectAll}
          >
            <FontAwesomeIcon icon={faBan} />
            Refuser tout
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;